import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Tenant } from '../models/tenant.model';
import { convertKeysToCamelCase } from '../../../shared/utilities/json-key-transform';
import { GetTenantListResponse } from '../models/get-tenant-list.response';
import { GetTenantRequest } from '../models/get-tenant-request';
import { GetTenantResponse } from '../models/get-tenant-response';
import { CreateTenantRequest } from '../models/create-tenant.request';
import { CreateTenantResponse } from '../models/create-tenant.response';
import { UpdateTenantRequest } from '../models/update-tenant.request';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private http = inject(HttpClient);
  private apiUrl = environment.tenantManagementApi.serviceBaseUrl;

  listTenants(): Observable<Tenant[]>  {
    return this.http.get<GetTenantListResponse>(this.apiUrl+"/GetTenantList").pipe(
      map(response => {
        let camelCase = convertKeysToCamelCase(response);
        return camelCase.licenses;
      }),
      catchError((error: HttpErrorResponse) => {
        error = convertKeysToCamelCase(error);
        return throwError(() => error.status + ": " + error.statusText);
      })
    );
  }

  getTenant(request: GetTenantRequest): Observable<Tenant> {
    return this.http.get<GetTenantResponse>(this.apiUrl+"/GetTenant/"+request.tenantId).pipe(
      map(response => {
        let camelCase = convertKeysToCamelCase(response) as GetTenantResponse;
        return camelCase.tenant;
      }),
      catchError((error: HttpErrorResponse) => {
        error = convertKeysToCamelCase(error);
        return throwError(() => error.status + ": " + error.statusText);
      })
    );
  }
  
  createTenant(request: CreateTenantRequest): Observable<string> {
    return this.http.post<CreateTenantResponse>(this.apiUrl+"/CreateTenant", request).pipe(
      map(response => {
        let camelCase = convertKeysToCamelCase(response) as CreateTenantResponse;
        if (camelCase.error !== null) {
          throw new Error(camelCase.error || 'An unexpected error occurred');
        }
        return camelCase.tenantId;
      }),
      catchError((error: HttpErrorResponse) => {
        error = convertKeysToCamelCase(error);
        return throwError(() => error.error.error);
      })
    );
  }

  updateTenant(request: UpdateTenantRequest): Observable<Tenant> {
    return this.http.patch<GetTenantResponse>(this.apiUrl + "/UpdateTenant", request).pipe(
      map(response => {
        let camelCase = convertKeysToCamelCase(response) as GetTenantResponse;
        return camelCase.tenant;
      }),
      catchError((error: HttpErrorResponse) => {
        error = convertKeysToCamelCase(error);
        return throwError(() => error.status + ": " + error.statusText);
      })
    );
  }
}
